import { EnumUserLocale } from 'modules/common/types/locale'
import { FALLBACK_LOCALE } from '_constants'
import { ConfigType } from '../types'

export const CA_CONFIG: ConfigType = {
  internalBankName: 'Propulse',
  locales: (process.env.NEXT_PUBLIC_AVAILABLE_LOCALES || FALLBACK_LOCALE).split(
    ','
  ) as EnumUserLocale[],
  hasSubBanks: true,
  signupConfig: {
    shouldDisplayOperatedBy: true,
    shouldDisplayCommercialSolicitationOptIn: true,
    canAccessManagementOffer: true,
    canAccessQuickSignup: false,
  },
  defaultPublicOfferCount: 2,
  caravelAffiliationCode: 'PROPULSEBYCA',
}
